import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { CompactFeedbackResponse, FeedbackId, FeedbackResponse } from '@business/entities/feedback';
import { FeedbackAPI } from '@business/api/feedback';
import { FeedbackFormData } from '@modules/common/FeedbackModal/FeedbackModal';

export class FeedbackBloc extends BaseBloc {
  private readonly feedbackRepo = new Repository<CompactFeedbackResponse | FeedbackResponse>({
    getItemId: item => item.id,
  });

  readonly ideas$ = this.feedbackRepo.items$;
  readonly selectIdea = this.feedbackRepo.selectItem;

  onReset() {
    this.feedbackRepo.reset();
  }

  fetchFeedbacks = () => {
    return FeedbackAPI.fetchFeedbacks().pipe(this.feedbackRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_feedbacks_error') }));
  };

  fetchFeedback = (id: FeedbackId) => {
    return FeedbackAPI.fetchFeedback(id).pipe(
      this.feedbackRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_feedbacks_error') }),
    );
  };

  createFeedback = (objectId: string, type: string, data: FeedbackFormData) => {
    return FeedbackAPI.createFeedback(objectId, type, data).pipe(
      this.feedbackRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('feedback_idea'),
      }),
    );
  };
}
